// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
	<path d="M13.9,7.7l4.3,4.3l-4.3,4.3l-0.7-0.7l3.1-3.1H7v-1h9.2l-3-3.1L13.9,7.7z M22,12c0,5.5-4.5,10-10,10S2,17.5,2,12S6.5,2,12,2
		S22,6.5,22,12z M21,12c0-5-4-9-9-9s-9,4-9,9s4,9,9,9S21,17,21,12z" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-arrow-right-circle-Dif3sPcx.js.map
